import React, { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import style from "./index.module.scss";
import MHeader from "components/MHeader";
import PageRadio from "./components/PageRadio";
import { Button } from "antd";
import className from "classnames";
import PageCheckBox from "./components/PageCheckBox";
import PageJudge from "./components/PageJudge";
import PageGapFilling from "./components/PageGapFilling";
import PageSubjective from "./components/PageSubjective";
import PageReading from "./components/PageReading";
import { PaperProps } from "../../../../../API/exercise";
import AnswerCardModal from "./components/ExerciseTopicButtons/components/AnswerCardModal";

interface ExerProps {
    data?: PaperProps;
    oneChange: (questionId: string, value: string) => void;
    moreChange: (questionId: string, value: any) => void;
    oneSave: (questionId: string, value: string) => void;
    moreSave: (questionId: string, value: any) => void;
    onSubmit: () => void;
    headerDom: React.ReactNode; //头部组件dom
    showExerciseBar: boolean;
    exerciseBarClose: () => void;
}

export default function ExerciseModule({
    data,
    oneChange,
    moreChange,
    oneSave,
    moreSave,
    onSubmit,
    headerDom,
    showExerciseBar,
    exerciseBarClose
}: ExerProps) {
    const history = useHistory();
    const [checked, setChecked] = useState(1); //当前选中

    // const currentData = useMemo(() => {data.topics.find((item,index) => (index + 1) === checked)},[data,checked])
    const currentData = useMemo(
        () => data?.topics.find((item, index) => index + 1 === checked),
        [data, checked]
    );

    function pageOneChange(questionId: string, value: string) {
        oneChange(questionId, value);
    }

    function pageMoreChange(questionId: string, value: any) {
        moreChange(questionId, value);
    }

    function pageOneSave(questionId: string, value: string) {
        oneSave(questionId, value);
    }

    function pageMoreSave(questionId: string, value: any) {
        moreSave(questionId, value);
    }

    return (
        <div className={style.root}>
            <MHeader title="提交练习" goBack={history.goBack} />
            {/*<div className={style.header}>*/}
            {/*</div>*/}
            {/*共多少题倒计时，点击答题卡按钮*/}
            {headerDom}
            {/*已答，未答试题号提交练习按钮*/}
            <AnswerCardModal
                onClose={exerciseBarClose}
                visible={showExerciseBar}
                onSubmit={onSubmit}
                checked={checked}
                data={data?.topics}
                onChange={(val: number) => setChecked(val)}
            />

            <div className={style.body}>
                {currentData &&
                    currentData.queTypeId == "1" &&
                    checked === currentData.index && (
                        <PageRadio data={currentData} oneSave={pageOneSave} />
                    )}
                {currentData &&
                    currentData.queTypeId == "2" &&
                    checked === currentData.index && (
                        <PageCheckBox
                            data={currentData}
                            moreSave={pageMoreSave}
                        />
                    )}
                {currentData &&
                    currentData.queTypeId == "3" &&
                    checked === currentData.index && (
                        <PageJudge data={currentData} oneSave={pageOneSave} />
                    )}
                {currentData &&
                    currentData.queTypeId == "4" &&
                    checked === currentData.index && (
                        <PageSubjective
                            data={currentData}
                            oneSave={pageOneSave}
                            oneChange={pageOneChange}
                        />
                    )}
                {currentData &&
                    currentData.queTypeId == "5" &&
                    checked === currentData.index && (
                        <PageGapFilling
                            data={currentData}
                            moreSave={pageMoreSave}
                            moreChange={pageMoreChange}
                        />
                    )}
                {currentData &&
                    currentData.queTypeId >= "6" &&
                    checked === currentData.index && (
                        <PageReading
                            data={currentData}
                            oneSave={pageOneSave}
                            moreSave={pageMoreSave}
                            oneChange={pageOneChange}
                            moreChange={pageMoreChange}
                        />
                    )}
            </div>

            <div className={style.footer}>
                <div className={style.footerDiv}>
                    {currentData && currentData.index !== 1 && (
                        <Button
                            className={className(style.prev, {
                                [style.one]: false
                            })}
                            onClick={() =>
                                setChecked(currentData.index - 1 || 1)
                            }>
                            上一题
                        </Button>
                    )}
                    {currentData &&
                        data &&
                        currentData.index !== data.topics.length && (
                            <Button
                                className={className(style.next, {
                                    [style.one]: false
                                })}
                                onClick={() =>
                                    setChecked(currentData.index + 1 || 1)
                                }>
                                下一题
                            </Button>
                        )}
                    {currentData &&
                        data &&
                        currentData.index === data.topics.length && (
                            <Button
                                className={className(style.next, {
                                    [style.one]: false
                                })}
                                onClick={() => onSubmit()}>
                                提交练习
                            </Button>
                        )}
                </div>
            </div>
        </div>
    );
}
